<template>
    <div class="result__cover__box">
        <!-- Result Summary Header -->
        <div class="result__summary__box__wrapper">
            <div class="result__summary__box">
                <div class="result__summary__head">
                    <div class="heading__text__wrapper">
                        <div class="rlms-flex rlms-items-center rlms-gap-10">
                            <h4 class="title">Result Summary</h4>
                            <div class="video__info__btn__item transcription-setting" style="padding: 0;">
                                <a href="https://www.youtube.com/watch?v=xUwRd5vFArM" target="_blank" rel="noopener" class="popup-youtube rlms-flex rlms-items-center" @click="showVideoTutorial = true">
                                    <span class="badge rlms-fw-600 rlms-flex rlms-items-center rlms-gap-5"><span class="material-symbols-outlined">help</span> Help</span>
                                </a>
                            </div>
                        </div>
                        <span class="head__info">Scores are automatically generated</span>
                        <span class="head__info">{{ EESA_SCOPE_NOTE }}</span>
                    </div>
                    <div class="print__data__btn">
                        <WorkpacketPdf :button-label="`Print Data`" :assessmentId="assessmentId"
                            :organizationId="organizationId" :learnerId="learnerId"
                            v-if="assessmentId && organizationId && learnerId" />
                    </div>
                </div>
            </div>

            <!-- Group Score Section -->
            <div class="result__data__content__wrapper">
                <template v-for="(group, key) in groupScores" :key="key">
                    <div class="result__group__box" :class="getGroupBoxClass(parseInt(key))">
                        <div class="group__text__wrapper">
                            <label>Group {{ key }}</label>
                            <h6 class="group__counter">{{ group.score }}/{{ group.total }}</h6>
                        </div>
                        <div class="group__score__ellipse">
                            <span class="score__text">{{ group.percentage }}%</span>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- Voice Bank Section -->
        <div class="result__voice__bank__wrapper">
            <h4 class="title">Average SCV</h4>
            <div class="sepline__divider"></div>

            <div class="voicebank__list__group__box">
                <template v-for="(scv, key) in scvAverages" :key="key">
                    <div class="voice__data__group__box" :class="getSCVBoxClass(parseInt(key))">
                        <div class="title__group">
                            <h6 class="group__title">Group {{ key }}</h6>
                            <div class="info__icon__btn">
                                <a href="javascript:void(0)" @click="analysisGroup = key; showAnalysisModal = true;">
                                    <img :src="infoIcon" alt="Info" />
                                </a>
                            </div>
                        </div>
                        <div class="sepline__divider"></div>
                        <template v-if="skip_group && (key == 1 || key == 2)">
                            <div class="voice__data__shortnote">
                                <p>You have skipped this section. Normal Score is 01 02 03</p>
                            </div>
                        </template>
                        <div class="data__group" v-else>
                            <div class="data__item__box">
                                <label>Syll</label>
                                <span>{{ scv.syllable }}</span>
                            </div>
                            <div class="data__item__box">
                                <label>C</label>
                                <span>{{ scv.consonant }}</span>
                            </div>
                            <div class="data__item__box">
                                <label>V</label>
                                <span>{{ scv.vowel }}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
    <BaseModal :visible="showAnalysisModal" @close="showAnalysisModal = false" :title="`Group ${analysisGroup}`"
        size="extra-large">
        <Analysis :assessmentId="assessmentId" :organizationId="organizationId" :learnerId="learnerId"
            :group="analysisGroup" class="info-popup" />
    </BaseModal>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import WorkpacketPdf from './workpacket/WorkpacketPdf.vue';
import infoIcon from '@/assets/images/info-circle-icon.png';
import Analysis from './workpacket/Analysis.vue';
import BaseModal from '../BaseModal.vue';
import { EESA_SCOPE_NOTE } from '@/utils/assessment-notes';
import $ from 'jquery';
import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

// Props from parent
const props = defineProps({
    assessment: Object
});

const showAnalysisModal = ref(false);
const analysisGroup = ref(1);

// Computed group score and SCV averages
const groupScores = computed(() => props.assessment?.result?.group_scores || []);
const scvAverages = computed(() => props.assessment?.result?.scv_averages || []);

const skip_group = computed(() => (props.assessment?.skip_group1 == 1 || props.assessment?.skip_group2 == 1));

const assessmentId = computed(() => props.assessment?.id);
const learnerId = computed(() => props.assessment?.learner?.id);
const organizationId = computed(() => props.assessment?.learner?.organization_id);

// Dynamic class for result score groups
const getGroupBoxClass = (groupId) => {
    switch (groupId) {
        case 1:
            return 'purple__group__box';
        case 2:
            return 'skyblue__group__box';
        case 3:
            return 'yellow__group__box';
        case 4:
            return 'dark__yellow__group__box';
        case 5:
            return 'dark__blue__group__box';
        default:
            return 'default__group__box';
    }
};

// Dynamic class for SCV group background
const getSCVBoxClass = (groupId) => {
    switch (groupId) {
        case 1:
            return props.assessment?.skip_group1 == 1 ? 'gray__bg' : 'light__purple__bg';
        case 2:
            return props.assessment?.skip_group2 == 1 ? 'gray__bg' : 'light__blue__bg';
        case 3:
            return 'dark__yellow__bg';
        default:
            return 'default__scv__bg';
    }
};

onMounted(() => {
    $('.popup-youtube').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
});
</script>
